import styled from 'styled-components';
import { tokens } from '../../../../../public/tokens';

const { colors, typography, globals } = tokens;

const STATUS_COLORS = {
    Active: colors.states.success,
    'Not Created': colors.states.warning,
    Revoked: colors.states.alert,
};

export const StatusPill = styled.span(({ $status }) => {
    const palette = STATUS_COLORS[$status] || colors.states.warning;

    return {
        display: 'inline-block',
        padding: '4px 12px',
        borderRadius: '999px',
        fontFamily: globals['font-family'],
        fontWeight: typography.fontWeights.semibold,
        fontSize: typography.fontSize['md-12px'],
        color: colors.neutral.white,
        backgroundColor: palette.default,
    };
});

export const GrantInfoPanel = styled.div({
    backgroundColor: colors.surfaces['page-background'],
    borderRadius: globals['border-radius'],
    padding: globals['spacing-lg'],
    height: '100%',
});

export const GrantInfoHeader = styled.div({
    display: 'flex',
    alignItems: 'center',
    gap: globals['spacing-sm'],
    marginBottom: globals['spacing-md'],
});

export const GrantInfoTitle = styled.div({
    fontFamily: globals['font-family'],
    fontWeight: typography.fontWeights.semibold,
    color: colors.text.primary,
});

export const GrantInfoText = styled.div({
    fontFamily: globals['font-family'],
    color: colors.text.secondary,
});
